import type { Template } from "../types/templates";

export const mockTemplates: Template[] = [
  {
    id: "t-001",
    name: "Master Service Agreement Template",
    createdBy: "John Smith",
    createdDate: "01-15-2024",
    status: "Active",
    templateCategory: "Contract",
    contractCategory: "MSA",
    businessUnits: ["All BUs", "TMHCC"],
    fileName: "MSA_Template_v2.pdf"
  },
  {
    id: "t-002",
    name: "Insurance Policy Standard Template",
    createdBy: "Jane Smith",
    createdDate: "02-12-2024",
    status: "Active",
    templateCategory: "Contract",
    contractCategory: "SOW",
    businessUnits: ["On Call", "MAM"],
    fileName: "Insurance_Policy_Standard.pdf"
  },
  {
    id: "t-003",
    name: "Premium Calculation Rules",
    createdBy: "Alice Tanaka",
    createdDate: "12-20-2023",
    status: "Inactive",
    templateCategory: "Contract",
    contractCategory: "NDA",
    businessUnits: ["TMHCC"],
    fileName: "Premium_Calc_Rules.docx"
  },
  {
    id: "t-004",
    name: "Non-Disclosure Agreement Template",
    createdBy: "Bob Yamamoto",
    createdDate: "03-01-2024",
    status: "Active",
    templateCategory: "Contract",
    contractCategory: "NDA",
    businessUnits: ["All BUs", "On Call", "TMHCC"],
    fileName: "NDA_Template_Final.pdf"
  }
];
